import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from 'styled-components';
import { getColor, getSpace } from '@yoweb/ui/styles/utils/theme';
import { media } from '@yoweb/ui/styles/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var ActionModalFooter = function ActionModalFooter(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(ModalFooter, {
    children: children
  });
};
var ModalFooter = styled.div.withConfig({
  componentId: "sc-1fmvcho-0"
})(["border-top:1px solid ", ";display:flex;flex-direction:column;padding:", ";row-gap:", ";", ""], getColor('base100'), getSpace('normal2'), getSpace('small4'), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  column-gap: ", ";\n  flex-direction: row-reverse;\n  justify-content: flex-start;\n"])), getSpace('small4')));